import useQueriesRunningInBackGround from 'hooks/useQueriesRunningInBackGround';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { toggleShowSetback } from 'store/slices/ToolSlice';
import { PanelElement } from '../style';
import SwitchToggle from 'components/Basic/SwitchToggle/SwitchToggle';
export default function ShowSetBack () {
	const { showSetback, hideSatelliteOverlay } = useSelector((state: RootState) => state.toolNewPostions.data);
	
	const dispatch = useDispatch<AppDispatch>();
	const queriesRunningInBackGround = useQueriesRunningInBackGround();

	const handleClick = () => {
		dispatch(toggleShowSetback({ showSetback: !showSetback }));
	};
	return (
		<PanelElement style={{ zIndex: 0 }}>
			<div className='switchButton showPanel'>
				<span>Show setbacks</span>
				<SwitchToggle 
					checked={showSetback}
					onChange={handleClick}
					disabled={queriesRunningInBackGround || hideSatelliteOverlay}
				/>
			</div>
		</PanelElement>
	);
}